import { buildingThresholdsApi } from './buildingsApi';
import { locationApi } from './locationApi';
import { partnerCustomerApi } from './partnerCustomer';
import { partnerHealthStatusApi, partnerDeviceSearchApi } from './partnerHealthStatusApi';
import { thresholdsApi } from './thresholdsApi';
import { wellReportApi } from './wellReportApi';

export * from './locationApi';
export * from './buildingsApi';
export * from './thresholdsApi';
export * from './partnerCustomer';
export * from './partnerHealthStatusApi';
export * from './wellReportApi';

export const businessApiSlices = [
    buildingThresholdsApi,
    locationApi,
    partnerCustomerApi,
    partnerDeviceSearchApi,
    partnerHealthStatusApi,
    thresholdsApi,
    wellReportApi,
];
